import { render, staticRenderFns } from "./CockpitMatryoshkaItemOperationsTab.vue?vue&type=template&id=2d0b2e52&scoped=true"
import script from "./CockpitMatryoshkaItemOperationsTab.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemOperationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0b2e52",
  null
  
)

export default component.exports